import {
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';

export const ConfirmationModal = ({
  title,
  isOpen,
  isCentered,
  onClose,
  body,
  cancelText,
  onCancel,
  continueText,
  onContinue,
  disabled,
  primaryActionButtonColor = 'blue',
  cancelButtonProps,
  continueButtonProps,
  modalContentProps = {},
  showTopCloseButton = true,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Modal isOpen={isOpen} isCentered={isCentered} onClose={onClose} {...props}>
      <ModalOverlay />
      <ModalContent position="relative" gap={0} margin={isMobileView() ? '10px' : '0px'} {...modalContentProps}>
        <ModalHeader
          fontSize="16px"
          padding="20px"
          position="relative"
          display="flex"
          alignItems="center"
          color={theme.colors.text.g1}
        >
          {title}
          {showTopCloseButton && (
            <ModalCloseButton
              style={{
                position: 'absolute',
                left: isMobileView() ? '0%' : '-3%',
                top: '-20%',
                backgroundColor: theme.colors.neutral[323846],
                color: 'white',
                border: '1px solid white',
                borderRadius: '40px',
                width: '28px',
                height: '28px',
              }}
            />
          )}
        </ModalHeader>
        <Divider
          width="auto"
          opacity={1}
          borderColor={theme.colors.border.CFD7DF}
          m="-1px 12px 0"
          boxSizing="border-box"
        />
        <ModalBody p="24px" color={theme.colors.text.g1}>
          {body}
        </ModalBody>
        <ModalFooter
          sx={{
            background: theme.colors.neutral.F5F7F9,
            borderTop: `1px solid ${theme.colors.border.CFD7DF}`,
            borderRadius: '0px 0px 8px 8px',
          }}
          p="15.5px 16px"
        >
          <Flex justifyContent={cancelText && continueText ? 'space-between' : 'flex-end'} width="100%">
            {cancelText && (
              <Button variant="tertiary" onClick={onCancel} disabled={disabled} {...cancelButtonProps}>
                {cancelText}
              </Button>
            )}
            {continueText && (
              <Button
                ml="16px"
                disabled={disabled}
                onClick={onContinue}
                color={primaryActionButtonColor}
                {...continueButtonProps}
              >
                {continueText}
              </Button>
            )}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
